import { render, staticRenderFns } from "./tri_point_resistance.vue?vue&type=template&id=36e5e1d7"
import script from "./tri_point_resistance.vue?vue&type=script&lang=js"
export * from "./tri_point_resistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports